import React from 'react'
import './nav.sass'
import Logo from '../assets/Logo.png'

function nav() {
  return (
    <nav><img src={Logo} alt="" style={{height: 'auto', width: 300}} /></nav>
  )
}

export default nav